import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { AUTH_TYPE } from '../../constants/auth';

/**
 * React HOC For Authentication.
 *
 * @param {React.Component} WrappedComponent Component to be wrapped.
 * @param {Object} options Options object.
 * @param {AUTH_TYPE} options.authType Type of auth to get.
 * @param {string} options.redirectUrl Custom auth URL in case auth is required.
 * @param {string} options.redirectSearch Custom search params to pass along
 */
const WithAuthentication = (WrappedComponent, options = {}) =>
  class extends Component {
    static propTypes = {
      authenticated: PropTypes.bool.isRequired,
      location: PropTypes.object,
      staticContext: PropTypes.object,
    };

    render() {
      const { authenticated, location, staticContext } = this.props;
      const authUrl =
        options.authType === AUTH_TYPE.PHONE
          ? '/auth/phone'
          : '/shutterbug/signin';

      // Set referrer so that we can redirect the user
      // at the previously requested page (server side)
      // This is then caught on server's `context` (provided by
      // StaticRouter and passed along to Express's redirect handler
      // (see `react-server-renderer.js`)
      if (staticContext && !authenticated) {
        staticContext.referrer = location;
        staticContext.status = 401;
      }

      return authenticated ? (
        <WrappedComponent {...this.props} />
      ) : (
        <Redirect
          to={{
            pathname: options.redirectUrl || authUrl,
            search: options.redirectSearch ?? location.search,
            state: {
              ...location.state,
              originalUrl:
                location.pathname + (location.search ? location.search : ''),
            },
          }}
        />
      );
    }
  };

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

export { WithAuthentication };

export default (WrappedComponent, options) => {
  return compose(connect(mapStateToProps), WithAuthentication)(
    WrappedComponent,
    options,
  );
};
